import { render, staticRenderFns } from "./JdsPanelHeading.vue?vue&type=template&id=254d534b&scoped=true&"
import script from "./JdsPanelHeading.vue?vue&type=script&lang=ts&"
export * from "./JdsPanelHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d534b",
  null
  
)

export default component.exports